/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import AppStack from '../../../../common/AppStack';
import WsSectionContainer from '../WsSectionContainer';
import AppText from '../../../../common/AppText';
import {
  doesResourcesHaveProducts,
  getSelectedResourceBaseNavigationUrl,
  getWebstoreHeadingSize
} from '../../../../../helpers/webstoreHelper';
import WsCategoryGridDisplay from './WsCategoryGridDisplay';

const WsCategoryGrid = ({
  blocks,
  config,
  themeConfig,
  colorSchemes,
  mediaQueries,
  pathname,
  ecomStoreTheme,
  onNavigate,
  baseStoreUrl,
  editModeEnabled,
  search,
  resourceNavigation,
  productCategories,
  pageWidth,
  selectedResources,
  ...rest
}) => {
  const colorScheme = colorSchemes[config.colorScheme - 1] ?? colorSchemes[0];
  const isSubcategoryList =
    resourceNavigation[resourceNavigation.length - 1]?.type ===
    'sub-categories';
  const baseResourceUrl = `${baseStoreUrl}${getSelectedResourceBaseNavigationUrl(
    resourceNavigation,
    isSubcategoryList ? 'sub-categories' : 'categories'
  )}`;
  const heading = isSubcategoryList
    ? config.subCategoryHeadingText
    : config.headingText;

  const {
    ecomCategory,
    ecomSubcategory,
    ecomStoreDesign,
    ecomStoreCollection
  } = selectedResources;

  const categoryValues = isSubcategoryList
    ? productCategories.subcategories.filter(
        (v) =>
          !!v &&
          doesResourcesHaveProducts(ecomStoreTheme, {
            pkEcomCategory: ecomCategory?.value,
            pkEcomVendorDesign: ecomStoreDesign?.pkEcomVendorDesign,
            pkEcomStoreCollection: ecomStoreCollection?.pkEcomStoreCollection,
            ecomSubcategory: v
          })
      )
    : productCategories.categories.filter(
        (v) =>
          !!v &&
          doesResourcesHaveProducts(ecomStoreTheme, {
            pkEcomCategory: v,
            pkEcomVendorDesign: ecomStoreDesign?.pkEcomVendorDesign,
            pkEcomStoreCollection: ecomStoreCollection?.pkEcomStoreCollection,
            ecomSubcategory: ecomSubcategory?.value
          })
      );

  return (
    <WsSectionContainer
      colorScheme={colorScheme}
      config={{
        ...config,
        fullWidth: 'true'
      }}
      mediaQueries={mediaQueries}
      themeConfig={themeConfig}
      {...rest}
    >
      <AppStack
        style={{
          flex: 1,
          justifyContent: 'space-between',
          margin: 'auto',
          width: '100%',
          alignItems: 'center',
          gap: 16
        }}
      >
        <AppStack
          style={{
            width: '100%',
            maxWidth: config.fullWidth === 'true' ? 'unset' : pageWidth,
            gap: 5
          }}
        >
          {heading && (
            <AppText
              style={{
                fontWeight: 600,
                fontSize: getWebstoreHeadingSize(config.headingSize)
              }}
            >
              {heading}
            </AppText>
          )}
          {config.descriptionText && (
            <AppText style={{ fontSize: 16 }}>{config.descriptionText}</AppText>
          )}
        </AppStack>

        <AppStack
          style={{
            flex: 1,
            justifyContent: 'space-between',
            margin: 'auto',
            width: '100%',
            maxWidth:
              config.categoriesFullWidth === 'true' ? 'unset' : pageWidth,
            gap: 0
          }}
        >
          <WsCategoryGridDisplay
            baseStoreUrl={baseResourceUrl}
            categoryValues={categoryValues}
            colorSchemes={colorSchemes}
            config={config}
            ecomStoreTheme={ecomStoreTheme}
            isSubcategoryList={isSubcategoryList}
            mediaQueries={mediaQueries}
            onNavigate={onNavigate}
          />
        </AppStack>
      </AppStack>
    </WsSectionContainer>
  );
};

WsCategoryGrid.propTypes = {
  baseStoreUrl: PropTypes.string,
  blocks: PropTypes.array,
  colorSchemes: PropTypes.array,
  config: PropTypes.object,
  ecomStoreTheme: PropTypes.object,
  editModeEnabled: PropTypes.bool,
  mediaQueries: PropTypes.object,
  onNavigate: PropTypes.func,
  pageWidth: PropTypes.number,
  pathname: PropTypes.string,
  productCategories: PropTypes.object,
  resourceNavigation: PropTypes.array,
  search: PropTypes.string,
  selectedResources: PropTypes.object,
  themeConfig: PropTypes.object
};

export default WsCategoryGrid;
